import styled from 'styled-components';

import BodyText from '@ui/atoms/BodyText';
import Button from '@ui/atoms/Ws-Button';

import theme from './WsTheme';

export const FooterCTA = styled(Button)`
	width: 25.6rem;

	p {
		color: ${theme.colors.white};
	}
`;

export const AddressContainer = styled.div``;

export const LegitScriptsBox = styled.div``;

export const FooterSection = styled.div``;

export const FooterContainer = styled.div`
	margin: 0 auto;
	max-width: 128rem;
	padding: 3rem 2rem;
	width: 100%;

	@media ${theme.responsive.breakpoints.tablet} {
		display: flex;
		max-width: 144rem;
		padding: 3rem 6rem 6rem;
	}
`;

export const StyledStaticLink = styled.a`
	text-decoration: none;

	> * {
		color: ${theme.colors.black};
		font-size: ${theme.fontSizes.body.sm};
		line-height: ${theme.lineHeights.body.sm};
	}
`;

export const Footer = styled.footer`
	display: flex;
	border-top: solid 1.5px #e4ded7;
	flex-flow: column;
	width: 100%;
	background: ${theme.colors.lightBeige};
	${theme.maxWidthCenter};
`;

export const SocialIconWrapper = styled.div`
	display: flex;
`;

export const SocialIcons = styled.div`
	display: flex;
	margin-left: auto;
	margin-top: 1rem;

	@media ${theme.responsive.breakpoints.tablet} {
		margin-top: 0;
	}

	${SocialIconWrapper} + ${SocialIconWrapper} {
		margin-left: 1.5rem;
	}
`;

export const LinkColumns = styled.div`
	@media ${theme.responsive.breakpoints.tablet} {
		display: grid;
		flex: 0 0 70%;
		grid-template-columns: 1fr 1fr 1fr;
	}
`;

export const LegalLinks = styled.div`
	display: flex;
	margin-bottom: 2rem;

	a {
		padding-right: 3rem;
	}

	@media ${theme.responsive.breakpoints.tablet} {
		margin-bottom: 0;
	}
`;

export const FooterBottomContainer = styled.div`
	margin: 0 auto;
	max-width: 128rem;
	padding: 0 2rem;

	@media ${theme.responsive.breakpoints.tablet} {
		display: flex;
		justify-content: space-between;
		max-width: 144rem;
		padding: 0 6rem;
	}
`;

export const FooterBottomBar = styled.div`
	background-color: ${theme.colors.black};
	color: ${theme.colors.white};
	padding: 16px 0;
	width: 100%;
	@media ${theme.responsive.breakpoints.tablet} {
		align-items: center;
	}
	> ${AddressContainer} {
		@media ${theme.responsive.breakpoints.tablet} {
			display: flex;
			width: 30%;
		}
	}
	${LegitScriptsBox} {
		@media ${theme.responsive.breakpoints.tablet} {
			display: flex;
			margin-top: 0;
			margin-left: 0;
		}
	}
	${BodyText} {
		color: ${theme.colors.white};
		font-size: 1.2rem;
	}
`;
